import { TableCell } from '@mui/material';

import { RegularText } from '@app/components/common/RegularText';
import { ColumnInterface, GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface RegularTextProps {
  column: ColumnInterface;
  row: GenericObject;
}

export const DefaultCell = ({ column, row }: RegularTextProps) => {
  return (
    <TableCell align="left" sx={{ maxWidth: 300 }}>
      <RegularText sx={{ maxHeight: 65, overflow: 'auto' }}>
        {column.format ? column.format(row) : row[column.key]}
      </RegularText>
    </TableCell>
  );
};
